// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { useScrollInfo } from '../../../../utils/hooks/useScrollInfo';
import '../../../../styles/global.css';
import './scrollableTabs.css';

export interface ScrollableTabsProps {
  buttons: JSX.Element[];
}

export const ScrollableTabs: React.FC<ScrollableTabsProps> = ({
  children,
  buttons,
  shouldOverflow = false,
  hasColorPicker = false,
  isWhite = false,
}) => {
  const parentRef = useRef();
  const [scrollInfo, setRef, ref] = useScrollInfo();
  const overflows =
    shouldOverflow || ref.current?.scrollWidth > ref.current?.clientWidth;

  const handleOnClick = (direction) => {
    if (typeof window !== 'undefined') {
      const scrollableTabs = ref.current;
      if (scrollableTabs) {
        const elementWidth = scrollableTabs.scrollWidth;
        if (direction === 'left') {
          scrollableTabs.scrollTo({
            top: 0,
            left: -elementWidth,
            behavior: 'smooth',
          });
        } else if (direction === 'right') {
          scrollableTabs.scrollTo({
            top: 0,
            left: elementWidth,
            behavior: 'smooth',
          });
        }
      }
    }
  };

  const buttonLeft = React.cloneElement(buttons[0], {
    onClick: () => handleOnClick('left'),
  });
  const buttonRight = React.cloneElement(buttons[1], {
    onClick: () => handleOnClick('right'),
  });

  return (
    <div
      ref={parentRef}
      className={`flex justify-items-start items-center ${
        hasColorPicker ? 'relative' : ''
      }`}>
      {scrollInfo.x.percentage > 0.1 && (
        <div
          className={`z-20 ${
            hasColorPicker
              ? 'rounded-r-full arrow-scrollable-tabs'
              : '-left-10 top-0 bottom-0 flex items-center'
          }`}>
          {buttonLeft}
        </div>
      )}
      <div
        ref={setRef}
        className={`flex overflow-x-scroll overflow-y-visible no-scrollbar ${
          !overflows ? 'w-full justify-left' : ''
        }`}>
        {children}
      </div>
      {overflows && scrollInfo.x.percentage < 0.9 && (
        <div
          className={` z-20 ${
            hasColorPicker
              ? 'rounded-l-full arrow-scrollable-tabs -right-0'
              : '-right-10 top-0 bottom-0 flex items-center'
          }`}>
          {buttonRight}
        </div>
      )}
    </div>
  );
};
